import { Search } from "@outschool/business-rules";
import { dayjs } from "@outschool/time";
import { filterToDayjs } from "@outschool/ui-components-website";

import { parseDate } from "./common";

export const filterDateFilters = (arr: Search.RelativeDateFilter[]) => {
  const newRelativeFilters = arr;

  const dayjsToday = () => dayjs().startOf("day");

  const summerFilterFirstDate = dayjsToday().set("month", 2).set("date", 1);
  const summerFilterLastDate = dayjsToday().set("month", 6).set("date", 31);

  const fallFilterFirstDate = dayjsToday().set("month", 5).set("date", 1);
  const fallFilterLastDate = dayjsToday().set("month", 9).set("date", 31);

  const januaryFilterFirstDate = dayjsToday().set("month", 10).set("date", 1);
  const januaryFilterLastDate = dayjsToday().set("month", 11).set("date", 31);

  if (
    dayjsToday().isAfter(summerFilterLastDate) ||
    dayjsToday().isBefore(summerFilterFirstDate)
  ) {
    removeFromRelativeDateFilters(
      Search.RelativeDateFilter.Summer,
      newRelativeFilters
    );
  }

  if (
    dayjsToday().isAfter(fallFilterLastDate) ||
    dayjsToday().isBefore(fallFilterFirstDate)
  ) {
    removeFromRelativeDateFilters(
      Search.RelativeDateFilter.Fall,
      newRelativeFilters
    );
  }

  if (
    dayjsToday().isAfter(januaryFilterLastDate) ||
    dayjsToday().isBefore(januaryFilterFirstDate)
  ) {
    removeFromRelativeDateFilters(
      Search.RelativeDateFilter.January,
      newRelativeFilters
    );
  }

  return newRelativeFilters;
};

const removeFromRelativeDateFilters = (
  relativeDateFilter: Search.RelativeDateFilter,
  newRelativeFilters: Search.RelativeDateFilter[]
) => {
  const index = newRelativeFilters.indexOf(relativeDateFilter);
  if (index > -1) {
    newRelativeFilters.splice(index, 1);
  }
};

export const filterToDayPicker = (startAfter: string, startBefore: string) => {
  const { startDayjs, endDayjs } = filterToDayjs(startAfter, startBefore);
  return {
    datePickerFrom: parseDate(startDayjs),
    datePickerTo: parseDate(endDayjs)
  };
};
